// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"iC-z","smallCardRow":"jC-z","largeCardRow":"kC-z","productSearchRow":"lC-z","curatedRow":"mC-z"};